const DEFAULT_CODE = process.env.REACT_APP_DEFAULT_COUNTRY_CODE || '+91';
export const DEFAULT_COUNTRY_CODE = DEFAULT_CODE.startsWith('+') ? DEFAULT_CODE : `+${DEFAULT_CODE}`;

export function ensureCountryCode(rawValue, countryCode = DEFAULT_COUNTRY_CODE) {
  if (rawValue === undefined || rawValue === null) return '';
  let value = String(rawValue).trim();
  if (!value) return value;

  value = value.replace(/[\s-]/g, '');
  if (value.startsWith('+')) {
    return value;
  }

  if (value.startsWith('00')) {
    return `+${value.slice(2)}`;
  }

  const normalizedCode = countryCode?.startsWith('+') ? countryCode : `+${countryCode || ''}`;
  const codeDigits = normalizedCode.slice(1);

  if (codeDigits && value.startsWith(codeDigits)) {
    return `+${value}`;
  }

  if (value.startsWith('0')) {
    value = value.slice(1);
  }

  return `${normalizedCode}${value}`;
}
